<template>
  <div  class="header text-center py-5 px-10 primary">
      <img src="@/assets/header-logo.png" alt="Tely">
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.header {
    position: absolute;
    right: 0%;
    top: 0%;
    width: 283px;
    height: 184px;
    z-index: 3;
    box-shadow: 0px 6px 0px rgba(255, 255, 255, 0.4), 0px 0px 32px rgba(35, 41, 46, 0.2);
    backdrop-filter: blur(24px);
    border-radius: 0px 0px 0px 64px;
}
</style>